import React from 'react';

interface ProTipProps {
  children: React.ReactNode;
  variant?: 'blue' | 'green' | 'orange' | 'purple';
  icon?: string;
  title?: string;
}

/**
 * ProTip Component - Displays helpful tips and guidance for users
 * Consistent styling across all form sections
 */
export const ProTip: React.FC<ProTipProps> = ({
  children,
  variant = 'blue',
  icon = 'fas fa-lightbulb',
  title = 'Pro Tip:'
}) => {
  const getBackgroundGradient = () => {
    switch (variant) {
      case 'green':
        return 'linear-gradient(135deg, #71ad08 0%, #5e8f07 100%)';
      case 'orange':
        return 'linear-gradient(135deg, #fe6718 0%, #ff8040 100%)';
      case 'purple':
        return 'linear-gradient(135deg, #574dc7 0%, #7b73fd 100%)';
      case 'blue':
      default:
        return 'linear-gradient(135deg, #085ec8 0%, #176fc9 100%)';
    }
  };

  return (
    <div
      className="pro-tip-container"
      style={{
        background: getBackgroundGradient(),
        color: 'white',
        padding: '1.25rem',
        borderRadius: '12px',
        marginTop: '1.5rem',
        marginBottom: '1rem',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '1rem',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        animation: 'fadeIn 0.5s ease-out'
      }}
    >
      <i
        className={icon}
        style={{
          fontSize: '1.25rem',
          marginTop: '0.125rem',
          opacity: 0.9
        }}
      ></i>
      <div style={{ flex: 1 }}>
        <strong style={{ marginRight: '0.5rem' }}>{title}</strong>
        {children}
      </div>
    </div>
  );
};

export default ProTip;